﻿const axios = require('axios');

const userStateApp = {
    data() {
        return {
            userApi: '',
            logoutApi: '',
            user: {},
            inactiveTimer: null,
            events: ['mousedown', 'mousemove', 'touchstart', 'touchmove', 'click', 'wheel', 'keypress', 'scroll', 'touchstart'],
            accessLevels: [],
            neutralPage: false,
            loggedIn: true,
            redirect: ''
        }
    },
    methods: {
        async init() {
            this.accessLevels = document.body.dataset.accesslevel.split(',');
            this.neutralPage = this.accessLevels.includes('Anonymous');
            if (sessionStorage.getItem('user') === null || !sessionStorage.getItem('user').hasOwnProperty('organisationAllowNewClaims')) {
                const response = await this.fetchData(this.userApi);
                if (!response || response.status != 200) {
                    this.loggedIn = false;
                    if (!this.neutralPage) location.href = this.redirect;
                } else {
                    if (response.data.success) {
                        sessionStorage.setItem('user', JSON.stringify(response.data.member));
                    } else {
                        this.loggedIn = false;
                        if (!this.neutralPage) location.href = this.redirect;
                    }
                }
            }
            if (this.loggedIn) {
                this.user = JSON.parse(sessionStorage.getItem('user'));
                if (!this.accessLevels.includes(this.user.roleName)) {
                    if (!this.neutralPage) location.href = '/';
                }
                this.$el.parentNode.classList.add('has-dropdown');
                let title = document.querySelector('.page-home .section-page-intro .title');
                if (title) {
                    title.innerHTML = title.textContent.replace('{{fullname}}', this.user.fullname);
                }
                this.inactivityTime();
                this.events.forEach((name) => {
                    window.addEventListener(name, this.inactivityTime, true);
                });
            }
        },
        async fetchData(url) {
            try {
                const response = await axios({
                    method: 'get',
                    url: url,
                    headers: { "Content-Type": 'multipart/form-data' },
                })
                return response;
            } catch (error) {
                console.log(error);
                this.loggedIn = false;
                if (!this.neutralPage) location.href = this.redirect;
            }
        },
        async logout() {
            const logoutResponse = await this.fetchData(this.logoutApi);
            if (!logoutResponse || logoutResponse.status != 200) return;
            if (logoutResponse.data) {
                this.$el.parentNode.classList.remove('has-dropdown');
                this.loggedIn = false;
                sessionStorage.removeItem('user');
                location.href = this.redirect;
            }
        },
        inactivityTime() {
            if (this.inactiveTimer) clearTimeout(this.inactiveTimer);
            // 28800000 ms = 8 hours
            this.inactiveTimer = setTimeout(() => { this.logout() }, 28800000);
        },
        dropdown(event) {
            let $link = event.currentTarget;
            let $parent = $link.parentNode;
            $parent.classList.toggle('is-active');
            document.addEventListener('click', (e) => {
                let isClickInside = false;
                if ($link.contains(e.target) || $parent.contains(e.target)) {
                    isClickInside = true;
                }
                if (!isClickInside) {
                    $parent.classList.remove('is-active');
                }
            });
        }
    },
    mounted() {
        if (this.$el.parentNode.dataset.useraction) this.userApi = this.$el.parentNode.dataset.useraction;
        if (this.$el.parentNode.dataset.logout) this.logoutApi = this.$el.parentNode.dataset.logout;
        if (this.$el.parentNode.dataset.redirect) this.redirect = this.$el.parentNode.dataset.redirect;
        this.init();
    }
}

export default userStateApp;
